import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotCalendar = ({ spotColor = "#C6F4EC", color = "#13126C", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#calendar_spot_40_svg__a)">
            <path
                fill={spotColor}
                d="M34.4 39.076c-6.746 2.775-12.172-1.247-18.456-4.857C9.534 30.002-.79 31.317.048 22.86c.665-6.725 8.407-7.027 14.496-11.029C20.6 7.835 23.221 5.904 28.44 7.638c5.183 1.739 10.16 5.108 11.292 11.247 1.098 6.143-1.28 17.657-5.332 20.19Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.2}
                d="M26.667 3.333v6.666M13.333 3.333v6.666M5 16.667h30m-26.667-10h23.334A3.333 3.333 0 0 1 35 10.001v23.333a3.333 3.333 0 0 1-3.333 3.333H8.333A3.333 3.333 0 0 1 5 33.334V10a3.333 3.333 0 0 1 3.333-3.333Z"
            />
        </g>
        <defs>
            <clipPath id="calendar_spot_40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotCalendar.displayName = "SpotCalendar";
